// extracted by mini-css-extract-plugin
module.exports = {"btn-course":"sendToTraining__btn-course","control-links":"sendToTraining__control-links","control-link":"sendToTraining__control-link","course-item":"sendToTraining__course-item"};